<div class="flex-auto p-6 sm:p-10">
    <div class="max-w-2xl prose prose-sm">
        <h1>{{ content.title }}</h1>

        <h2>{{ content.heading }}</h2>

        <p>{{ content.text }}</p>
    </div>
</div>
